import React, { useState } from 'react';
import {
  DepartmentFormattedData,
  DepartmentFormValues,
  departmentSchema,
  initialFormValues,
  BoPhanSuDungTSCD
} from '../../schema';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import DepartmentForm from './BasicInfoTab';
import { toast } from '@/hooks/use-toast';
import { BoPhan } from '@/types/schemas';
import { FormMode } from '@/types/form';

interface DepartmentDialogProps {
  open: boolean;
  mode: FormMode;
  initialData?: DepartmentFormValues | BoPhanSuDungTSCD;
  onClose: () => void;
  onSubmit?: (data: DepartmentFormattedData) => void;
  selectedObj?: BoPhanSuDungTSCD | null;
  updateDepartment?: (uuid: string, data: DepartmentFormattedData) => Promise<BoPhanSuDungTSCD>;
  addDepartment?: (data: DepartmentFormattedData) => Promise<BoPhanSuDungTSCD>;
  // Additional props for view mode actions
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

function DepartmentDialog({
  open,
  mode,
  initialData,
  onClose,
  onSubmit,
  selectedObj,
  updateDepartment,
  addDepartment,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}: DepartmentDialogProps) {
  const [boPhan, setBoPhan] = useState<BoPhan | null>(selectedObj?.ma_bp_phi_data || null);

  const handleSubmit = async (data: DepartmentFormValues) => {
    if (!boPhan || !boPhan.uuid) {
      toast({
        description: 'Mã bộ phận phí không được để trống',
        variant: 'destructive'
      });
      return;
    }

    const formattedData: DepartmentFormattedData = {
      ma_bp: data.ma_bp,
      ten_bp: data.ten_bp,
      ten_bp2: data.ten_bp2 || null,
      ma_bp_phi: boPhan?.uuid || null,
      ghi_chu: data.ghi_chu || null,
      status: String(data.status)
    };

    try {
      if (mode === 'edit' && selectedObj && updateDepartment) {
        await updateDepartment(selectedObj.uuid, formattedData);
      }
      if (mode === 'add' && addDepartment) {
        await addDepartment(formattedData);
      } else if (onSubmit) {
        onSubmit(formattedData);
      }

      onClose();
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  const title = mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem chi tiết';

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title={title}
      maxWidth='lg'
      disableBackdropClose={true}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
      paperClassName='w-[min(760px,calc(100vw-16px))]'
    >
      <AritoFormV2<DepartmentFormValues>
        mode={mode}
        hasAritoActionBar={false}
        schema={departmentSchema}
        onSubmit={handleSubmit}
        initialData={(initialData || initialFormValues) as Partial<DepartmentFormValues>}
        className='w-full min-w-0 max-w-full'
        headerFields={<DepartmentForm mode={mode} boPhan={boPhan} setBoPhan={setBoPhan} />}
        bottomBar={
          <BottomActionBarV2
            mode={mode}
            onAdd={onAddButtonClick}
            onEdit={onEditButtonClick}
            onDelete={onDeleteButtonClick}
            onCopy={onCopyButtonClick}
            onClose={onClose}
            submitTitle='Đồng ý'
          />
        }
      />
    </DialogV2>
  );
}

export default DepartmentDialog;
